"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productionStatisticTypes = void 0;
exports.productionStatisticTypes = {
    SET_ERROR: 'PRODUCTION STATISTIC TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'PRODUCTION STATISTIC TYPES GET DATA GRID',
    SET_IS_LOADING: 'PRODUCTION STATISTIC TYPES SET IS LOADING',
    ON_PAGE_CHANGE: 'PRODUCTION STATISTIC TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'PRODUCTION STATISTIC TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'PRODUCTION STATISTIC TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'PRODUCTION STATISTIC TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'PRODUCTION STATISTIC TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'PRODUCTION STATISTIC TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'PRODUCTION STATISTIC TYPES SET SUCCESS MODAL',
    ON_DATE_CHANGE: 'PRODUCTION STATISTIC TYPES ON DATE CHANGE',
    ON_FILTER_PAGE_CHANGE: 'PRODUCTION STATISTIC TYPES ON FILTER PAGE CHANGE',
    SET_EXPORT_DOCUMENTS_URL: 'PRODUCTION STATISTIC TYPES SET EXPORT DOCUMENTS URL',
    CLEAR_EXPORT_DOCUMENTS_URL: 'OPERATOR ATTENDANCE TYPES CLEAR EXPORT DOCUMENTS URL',
};
